import { CentraJS } from "@frend-digital/centra-js-client";
import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";
import { ofetch } from "ofetch";

export interface GiftVariables {
  certificate: string;
}

export interface CustomGiftVariables extends GiftVariables {
  amount: number;
}

export type AddGiftCertOptions<
  FormattedSelection,
  Variables = GiftVariables,
> = {
  variables: Variables;
  giftToken: string;
  apiUrl: string;
  formatter: (selection: BaseSelectionResponse) => FormattedSelection;
};

export const addCustomGiftCertificate = async <FormattedSelection>({
  variables,
  giftToken: customerToken,
  apiUrl: api,
  formatter,
}: AddGiftCertOptions<FormattedSelection, CustomGiftVariables>) => {
  CentraJS.suspend();

  const res = await ofetch(
    `${api}/items/gift-certificates/${variables.certificate}/amount/${variables.amount}`,
    {
      headers: {
        "API-token": customerToken || "",
        "Content-Type": "application/json",
      },
      method: "POST",
    }
  );

  CentraJS.resume();

  return formatter(res);
};

export const addGiftCertificate = async <FormattedSelection>({
  variables,
  giftToken: customerToken,
  apiUrl: api,
  formatter,
}: AddGiftCertOptions<FormattedSelection, { certificate: string }>) => {
  CentraJS.suspend();

  const res = await ofetch(
    `${api}/items/gift-certificates/${variables.certificate}`,
    {
      headers: {
        "API-token": customerToken || "",
        "Content-Type": "application/json",
      },
      method: "POST",
    }
  );

  CentraJS.resume();

  return formatter(res);
};
